import {
  GET_MEASUREMENTS_FAILED,
  GET_MEASUREMENTS_PENDING,
  GET_MEASUREMENTS_SUCCESS,
} from '../actionTypes'

const measurementsStates = {
  getMeasurementsPending: false,
  measurements: null,
  getMeasurementsError: null,
}

const measurementsReducer = (state = measurementsStates, { type = '', payload = {} }) => {
  switch (type) {
    case GET_MEASUREMENTS_PENDING: {
      return {
        ...state,
        getMeasurementsPending: true,
      }
    }

    case GET_MEASUREMENTS_SUCCESS: {
      return {
        ...state,
        getMeasurementsPending: false,
        measurements: payload,
      }
    }

    case GET_MEASUREMENTS_FAILED: {
      return {
        ...state,
        getMeasurementsPending: false,
        getMeasurementsError: payload,
      }
    }

    default:
      return state
  }
}

export default measurementsReducer
